import styled from "styled-components"
import Button from './atoms/Buttons'

export const ContentButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`

// Variante por defecto en attrs: React 19 ya no aplica defaultProps a componentes de función.
const ButtonCustom = styled(Button).attrs((props) => ({ variant: props.variant === undefined ? 'primary' : props.variant }))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  text-transform: uppercase;
  line-height: normal;
  font-weight: 700;
  text-align:center;
  font-size:24px;
  cursor: pointer;
  min-width:180px;
 `

export default ButtonCustom
